import {
  CARD_TYPES,
  CARD_DYNAMIC_TYPES,
  GALLERY_CARD_TYPES,
} from '../../constants';

export const isInsetColumn = ({ offset }) =>
  offset.large === 2 && offset.medium === 2 && offset.small === 0;

export const hasSlideshowWithInsetColumn = (column, cardType) =>
  isInsetColumn(column) && CARD_TYPES.SLIDESHOW === cardType;

export const hasGalleriesOrDynamicCards = cardType =>
  Object.values(CARD_DYNAMIC_TYPES).includes(cardType) ||
  GALLERY_CARD_TYPES.includes(cardType);
